import { DayOfWeek } from "../../interfaces";

import { Media, Prompt } from "./Prompt";
import { Category } from "../models";
import { EligibilityCriterion } from "@/services/bedrock";

export type CampaignDeliveryMode = "RANDOM_DELIVERY" | "SPECIFIC_DATE" | "ORDERED_RANDOM";
export type CampaignStatus = "ACTIVE" | "DISABLED" | "DRAFT" | "DELETED";

export const timeKey = "deliveryTimeUtc";
export const dateKey = "deliveryDateUtc";
export const titleKey = "title";
export const snKey = "socialNetworks";

export interface PromptCampaign {
  campaignPromptId?: string;
  deliveryDatetimeUtc?: string;
  socialNetworks: string[];
  promptId: string;
  sortOrder?: number;
  prompt?: Prompt;
}

interface SelectedDay {
  dayOfWeek: DayOfWeek;
  time?: string;
}

interface CampaignAccessRequest {
  eligibilityCriteria: EligibilityCriterion[];
  subscribedPlayerIds: number[];
}

export interface CampaignAccess extends CampaignAccessRequest {
  pendingPlayerIds?: number[];
  eligiblePlayerIds?: number[];
  accessUsers?: AccessUser[];
}

export interface AccessUser {
  userId: number;
  email: string;
  name: string;
  isAssistant: boolean;
  hasReadAccess: boolean;
  hasWriteAccess: boolean;
  hasEligibilityAccess: boolean;
}

export interface CampaignRequest {
  campaignId?: string;
  name: string;
  isAutoPost?: boolean;
  autoEnroll?: boolean;
  campaignPrompts: PromptCampaign[];
  categoryIds?: (string | number)[];
  deliveryMode: CampaignDeliveryMode;
  campaignAccess?: CampaignAccessRequest;
  randomScheduleDays?: SelectedDay[];
  randomScheduleDeliveryTimePst?: string;
  deliveryTimeDatePicker?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}

export interface CampaignEditRequest {
  campaignId?: string;
  name: string;
  isAutoPost?: boolean;
  autoEnroll?: boolean;
  campaignPrompts: PromptCampaign[];
  categoryIds?: (string | number)[];
  deliveryMode: CampaignDeliveryMode;
  eligibilityCriteria?: EligibilityCriterion[];
  randomScheduleDays?: SelectedDay[];
  randomScheduleDeliveryTimePst?: string;
  campaignAccess?: CampaignAccessRequest;
  startDate?: string;
  endDate?: string;
  status?: string;
  shuffle?: boolean;
}

export interface Campaign extends CampaignRequest {
  coachId?: string;
  isProcessing: boolean;
  creationDate?: string;
  // prompts?: PromptCampaign[];
  socialNetworks?: { [key: string]: boolean };
  categories?: Category[];
  campaignAccess?: CampaignAccess;
}

export interface CampaignStatusResponse {
  campaignId: number;
  coachId: number;
  status: CampaignStatus;
  isProcessing: boolean;
}

export interface EditableCampaign extends CampaignRequest {
  prompts?: PromptCampaign[];
  campaignAccess?: CampaignAccess;
}

export interface CampaignResume {
  campaignId: string;
  campaignName: string;
  coachId: string;
  createdDate: string;
  firstPromptMedia: Media;
  promptCount: number;
  subscribedPlayerCount: number;
  categoryIds: (string | number)[];

  campaignStatus: string;
  campaignAccess: CampaignAccess;
}

export interface CampaignSubscriptionResponse {
  campaignPlayerIds: string[];
}

export interface CampaignStep {
  validations: () => Promise<any | void>;
}

export interface PlayerCampaign {
  campaignName: string;
  campaignId: number;
  isAutoPost: boolean;
}

export interface CampaignListSubscriptionResponse {
  campaignIds?: number[];
}
